var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DetailImages"},_vm._l((_vm.images),function(img){return _c('div',{staticClass:"imgs"},[_c('my_image',{staticClass:"img",attrs:{"src":img,"width":'17vw'}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }